enum WorkspaceProjectMilestoneMultiItemStatus {
  draft = 'draft',
  pending = 'pending',
  completed = 'completed',
  failed = 'failed',
}

export default WorkspaceProjectMilestoneMultiItemStatus
